/**
 * Localised error strings.
 * When VITE_LOCALIZATION_ENABLED is truthy each getter delegates to i18next.
 * When the flag is off the original hardcoded English strings are returned,
 * preserving identical behaviour to pre-i18n code.
 */
import i18next from 'i18next'

function getError(key: string, fallback: string): string {
	const flag = import.meta.env.VITE_LOCALIZATION_ENABLED
	if (!flag || flag === 'false') return fallback
	return i18next.t(key)
}

export const errors = {
	get FILE_UPLOAD_ISSUE() {
		return getError('errors.fileUploadIssue', "Uh-oh! The image upload didn't go through. Give it another shot.")
	},
	get SERVER_ERROR() {
		return getError('errors.serverError', "Server's taking a nap. Try again soon!")
	},
	get REMOVE_VIDEO_ERROR() {
		return getError(
			'errors.removeVideoError',
			"Can't let go of that video right now. Give it a minute and try again.",
		)
	},
	get SAVE_VIDEO_ERROR() {
		return getError('errors.saveVideoError', "The server's feeling shy. Couldn't save the video—try again!")
	},
	get VIDEO_SUGGESTION_ERROR() {
		return getError(
			'errors.videoSuggestionError',
			"Oops, we've watched too much! YouTube's asking for a time-out, Check back later!",
		)
	},
}
